import * as React from "react";
import { useEffect } from "react";
import FooterOracle from "../components/FooterOracle.tsx";
import FrequentlyAskedQuestions from "../components/FrequentlyAskedQuestions.tsx";
import NavOracle from "../components/Navbar-oracle.tsx";
import Oracle1 from "../components/Oracle1.tsx";
import Oracle2 from "../components/Oracle2.tsx";
import OracleAlgoPricing from "../components/OracleAlgoPricing.tsx";
import OracleTrustedBy from "../components/OracleTurstedBy.tsx";

function Oracle() {
  useEffect(() => {
    // Change the body background color
    document.body.style.backgroundColor = "#F5F5F5"; // Black color

    // Update meta tags for OracleAlgo page
    const updateMetaTag = (property: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;

      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Update title
    document.title = "OracleAlgo";

    // Update description
    updateMetaTag('description', 'AI-powered trading indicators for crypto. Explore our full OracleAlgo suite, access exclusive tools, and discover early signals for trending price movements to level up your trading edge.');

    // Update Open Graph tags
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:url', 'https://unityacademy.io/oraclealgo', true);
    updateMetaTag('og:title', 'OracleAlgo', true);
    updateMetaTag('og:description', 'AI-powered trading indicators for crypto. Explore our full OracleAlgo suite, access exclusive tools, and discover early signals for trending price movements to level up your trading edge.', true);
    updateMetaTag('og:image', 'https://media.discordapp.net/attachments/1292444431294926938/1412097811482153121/image.png?ex=68b70e11&is=68b5bc91&hm=6aa17dea459ab64bdc791fe5dd32e4e3c493a9fa74286e3c220c7a8c425a93a0&=&format=webp&quality=lossless&width=550&height=309', true);

    // Update Twitter tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:url', 'https://unityacademy.io/oraclealgo', true);
    updateMetaTag('twitter:title', 'OracleAlgo', true);
    updateMetaTag('twitter:description', 'AI-powered trading indicators for crypto. Explore our full OracleAlgo suite, access exclusive tools, and discover early signals for trending price movements to level up your trading edge.', true);
    updateMetaTag('twitter:image', 'https://media.discordapp.net/attachments/1292444431294926938/1412097811482153121/image.png?ex=68b70e11&is=68b5bc91&hm=6aa17dea459ab64bdc791fe5dd32e4e3c493a9fa74286e3c220c7a8c425a93a0&=&format=webp&quality=lossless&width=550&height=309', true);

    // Cleanup to reset the background color when the component unmounts
    return () => {
      document.body.style.backgroundColor = ""; // Reset to default

      // Reset meta tags to default values
      document.title = "Unity Academy";
      updateMetaTag('description', 'Unity Academy Official Website');
      updateMetaTag('og:title', 'Unity Academy', true);
      updateMetaTag('og:description', 'Unity Academy Official Website', true);
      updateMetaTag('twitter:title', 'Unity Academy', true);
      updateMetaTag('twitter:description', 'Unity Academy Official Website', true);
    };
  }, []);
  return (
    <div className="h-full relative bg-black overflow-hidden z-0">
      {/* Background image inside, below all content */}
      <img src="images/hero-bg.png" className="absolute top-0 left-0 w-full z-5 h-[70vh]" alt="Hero Background" />
      {/* <img src="images/video-bg.png" className="absolute top-[520px] left-0 w-full z-5" /> */}
      {/* Content container with higher z-index */}
      <div className="relative z-10">
        <NavOracle />
        <div className="flex flex-col items-center justify-center overflow-hidden">
          <Oracle1 />
          <Oracle2 />
        </div>
        <OracleTrustedBy />
        <div className="flex flex-col items-center justify-center mx-4 mt-20 py-20 bg-cover rounded-[35px] bg-center bg-no-repeat relative">
          <OracleAlgoPricing />
          {/* <JoinCommunity /> */}
        </div>
        <div className="pt-10 relative">
          <img src="images/faq-bg.png" className="absolute bottom-[65%] right-[-15%] lg:bottom-[15%] lg:right-[-25%] w-full -z-[2]" alt="FAQ Background" />
          <img src="images/footer-background.png" className="absolute bottom-[0] max-lg:h-[50vh] w-full -z-[2]" alt="Footer Background" />
          <FrequentlyAskedQuestions textColor="white" />
          <FooterOracle />
          <div className="h-12 max-lg:hidden" />
        </div>
      </div>
    </div>
  );
}

export default Oracle;